import React from "react";
import styles from "./UploadSpinner.module.scss";
function UploadSpinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loader
  });
}
export default UploadSpinner;
//# sourceMappingURL=UploadSpinner.js.map